<template>
<div>
  <div><el-alert :title="data.title" type="success" :closable="false"></el-alert></div>
  <div class="webLetterCard"><img :src="data.card"></div>

</div>
</template>

<script>
export default {
name: "webLetterCard",
  data() {
    return {
      teamID: '',
      UUID: '',
      loading: true,
      data: {
        'card': '',
        'title': ''
      }
    }
  },
  mounted() {
    this.teamID = this.$route.query.teamID
    this.UUID = this.$route.query.UUID
    this.getLetterCard()
  },

  methods:{
    //获取账号信息
    getLetterCard()
    {
      this.$https({url: 'letterCard?teamID='+this.teamID,method: "get"}).then(backData => {
        if (backData.data.status === 200)
        {
          this.data.card = backData.data.data.card
          this.data.title = '微信扫描识别下方二维码添加客服：【'+backData.data.data.nickname+'】';
        }
      });
    },

  },
}

</script>

<style scoped>
.webLetterCard{
  padding: 16px;
}
.webLetterCard img{
  width: 100%;
  height: 260px;
}
</style>


// WEBPACK FOOTER //
// src/components/letter/webLetterCard.vue